import { FooterLinkProps, LocaleSpecific } from './types';

const normalizeLocale = (locale?: string) => locale?.trim().replace(/-/g, '_').toLowerCase();

const northAmericaLocales = new Set([
  normalizeLocale(LocaleSpecific.EN_US),
  normalizeLocale(LocaleSpecific.EN_CA),
  normalizeLocale(LocaleSpecific.FR_CA),
]);

export const filteredLocaleSpecificFooterData = (footerData: FooterLinkProps[], locale?: string) => {
  const normalizedLocale = normalizeLocale(locale);
  const normalizedEnglishCanadaLocale = normalizeLocale(LocaleSpecific.EN_CA);
  const normalizedFrenchCanadaLocale = normalizeLocale(LocaleSpecific.FR_CA);

  return footerData.filter(({ localeSpecific }) => {
    if (!localeSpecific) {
      return true;
    }

    if (localeSpecific === LocaleSpecific.BOTH) {
      return normalizedLocale ? northAmericaLocales.has(normalizedLocale) : false;
    }

    const normalizedLocaleSpecific = normalizeLocale(localeSpecific);

    return (
      normalizedLocaleSpecific === normalizedLocale ||
      (normalizedLocaleSpecific === normalizedEnglishCanadaLocale && normalizedLocale === normalizedFrenchCanadaLocale)
    );
  });
};
